import Component from '@glimmer/component';

export default class ApplicationLoading extends Component {
  <template>
    <div class='login loading'></div>
  </template>
}
